
import { Vue, Component, Prop } from 'vue-property-decorator';
import TooltipNewClick from '@/components/common/TooltipNewClick.vue';

@Component({
	components: {
		TooltipNewClick,
	},
})
export default class MoreActionsClick extends Vue {
	@Prop({ type: Boolean, default: undefined })
	readonly TooltipBoxStyle?: String;
}
